import React, { useState, useEffect } from "react";
import "./TopMenuBar.css";
import wifiIcon from "./assets/wifi.png";
import searchIcon from "./assets/search.png";
import controlCenterIcon from "./assets/controlcenter.png";
import batteryIcon from "./assets/battery.png";

const TopMenuBar = () => {
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 30000); // Update every 30 seconds instead of every second
    return () => clearInterval(timer);
  }, []);

  const formatTime = (date) => {
    const weekday = date.toLocaleString("en-US", { weekday: "short" });
    const month = date.toLocaleString("en-US", { month: "short" });
    const day = date.getDate();
    const hour = date.getHours();
    const minute = date.getMinutes().toString().padStart(2, "0");

    return (
      <>
        {weekday} {month} {day} {hour}
        <span className="colon">:</span>
        {minute}
      </>
    );
  };

  return (
    <div className="top-menu-bar">
      <div className="menu-left">
        <div className="apple-menu">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 814 1000"
            width="13"
            height="15"
          >
            <path
              fill="currentColor"
              d="M788.1 340.9c-5.8 4.5-108.2 62.2-108.2 190.5 0 148.4 130.3 200.9 134.2 202.2-.6 3.2-20.7 71.9-68.7 141.9-42.8 61.6-87.5 123.1-155.5 123.1s-85.5-39.5-164-39.5c-76.5 0-103.7 40.8-165.9 40.8s-105.6-57-155.5-127C46.7 790.7 0 663 0 541.8c0-194.4 126.4-297.5 250.8-297.5 66.1 0 121.2 43.4 162.7 43.4 39.5 0 101.1-46 176.3-46 28.5 0 130.9 2.6 198.3 99.2zm-234-181.5c31.1-36.9 53.1-88.1 53.1-139.3 0-7.1-.6-14.3-1.9-20.1-50.6 1.9-110.8 33.7-147.1 75.8-28.5 32.4-55.1 83.6-55.1 135.5 0 7.8 1.3 15.6 1.9 18.1 3.2.6 8.4 1.3 13.6 1.3 45.4 0 102.5-30.4 135.5-71.3z"
            />
          </svg>
        </div>
        <div className="app-name">Code</div>
        <div className="menu-items">
          <span>File</span>
          <span>Edit</span>
          <span>Selection</span>
          <span>View</span>
          <span>Go</span>
          <span>Run</span>
          <span>Terminal</span>
          <span>Window</span>
          <span>Help</span>
        </div>
      </div>
      <div className="menu-right">
        <img
          src={batteryIcon}
          alt="Battery"
          className="topbar-icon"
          draggable="false"
          onContextMenu={(e) => e.preventDefault()}
        />
        <img
          src={wifiIcon}
          alt="WiFi"
          className="topbar-icon"
          draggable="false"
          onContextMenu={(e) => e.preventDefault()}
        />
        <img
          src={searchIcon}
          alt="Search"
          className="topbar-icon"
          draggable="false"
          onContextMenu={(e) => e.preventDefault()}
        />
        <img
          src={controlCenterIcon}
          alt="Control Center"
          className="topbar-icon"
          draggable="false"
          onContextMenu={(e) => e.preventDefault()}
        />
        <div className="time-display">{formatTime(currentTime)}</div>
      </div>
    </div>
  );
};

export default TopMenuBar;
